import { useContext } from "react";
import { SchemaProviderContext } from "components/SchemaProvider/SchemaProvider";

export const useSchemaProviderContext = () => useContext(SchemaProviderContext);
